import React from "react";
import Typography from "@material-ui/core/Typography";
const Contract = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Contract
      </Typography>
      <Typography paragraph variant="h5">
        Create an umbrella contract for vendor long-term agreement
      </Typography>
      <Typography paragraph variant="body1">
        Contract is one of the features under the Procurement module to perform
        purchasing transactions particularly to binding long-term purchase
        agreements with vendors. It contains any information regarding the
        vendor address & contact, currency & exchange rate used for the
        transaction, applied terms & conditions, contract duration, and the
        contract items detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Contract list. It
        is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Contract ID</b>
        <br />
        Indicates the ID of the Contract.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Name</b>
        <br />
        Indicates the name of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Validity Start Date</b>
        <br />
        Indicates the validity start date of the Contract.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Validity End Date</b>
        <br />
        Indicates the validity end date of the Contract.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Contract Status</b>
        <br />
        Indicates the contract status of the Contract. There are 2 statuses:
        Active and Expired.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Total Price</b>
        <br />
        Indicates the total price of the Contract.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Contract data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Contract</b>
        <br />
        This button only appears if the approval indicator is not 'Document
        Waiting For Approval'. It is used to edit the Contract data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Contract Detail</b>
        <br />
        This button is used to navigate to the Contract detail which contains
        some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Contract data.
          </li>
          <li>
            <b>Purchase Orders</b> : This tab is to display any Purchase Orders
            related to the Contract.
          </li>
          <li>
            <b>Goods Received</b> : This tab is to display any Goods Received
            related to the Contract.
          </li>
          <li>
            <b>A/P Invoices</b> : This tab is to display any A/P Invoices
            related to the Contract.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Contract.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Contract.
          </li>
        </ul>
        When opening the Contract detail, there will be 1 button appearing on
        the top section. The button is 'Edit Contract' which is used to edit the
        Contract data. The button only appears when the the approval indicator
        is not 'Document Waiting For Approval'.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Contract</b>
        <br />
        This button only appears if the approval indicator is not 'Document
        Waiting For Approval'. It is used to delete the Contract data. The
        Contract data is undeletable once it has relations with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Contract document could have an approval flow if it is configured.
        The approval indicator appears as an icon after the document ID. There
        are 4 approval indicators: Document No Need Approval, Document Waiting
        For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default Contract;
